import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Account } from '@shared/models/account.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private resourceUrl = '/api';

  constructor(private http: HttpClient) {}

  getAccount(): Observable<Account> {
    return this.http.get<Account>(this.resourceUrl + '/account');
  }

  saveAccount(account: Account): Observable<Account> {
    return this.http.post<Account>(this.resourceUrl + '/account', account);
  }
}
